// extracted by mini-css-extract-plugin
export default {"value":"rBFRYPDg5Hn2O0A4b_tg","pill":"XATPX6sdcoqIFk4oOimM","autocomplete":"Z2CaugOaJjKHBsLxUYVg"};